module.exports = __webpack_public_path__ + "img/logo.2a104b51.png";